/**
 * @hidden
 */
export var CommonErrors;
(function (CommonErrors) {
    CommonErrors[CommonErrors["NA"] = 0] = "NA";
    CommonErrors[CommonErrors["Value"] = 1] = "Value";
    CommonErrors[CommonErrors["Ref"] = 2] = "Ref";
    CommonErrors[CommonErrors["DivZero"] = 3] = "DivZero";
    CommonErrors[CommonErrors["Num"] = 4] = "Num";
    CommonErrors[CommonErrors["Name"] = 5] = "Name";
    CommonErrors[CommonErrors["Null"] = 6] = "Null";
    CommonErrors[CommonErrors["Calc"] = 7] = "Calc";
})(CommonErrors || (CommonErrors = {}));
/**
 * @hidden
 */
export var FormulasErrorsStrings;
(function (FormulasErrorsStrings) {
    FormulasErrorsStrings[FormulasErrorsStrings["OperatorsCannotStartWithExpression"] = 0] = "OperatorsCannotStartWithExpression";
    FormulasErrorsStrings[FormulasErrorsStrings["ReservedWordAND"] = 1] = "ReservedWordAND";
    FormulasErrorsStrings[FormulasErrorsStrings["ReservedWordXOR"] = 2] = "ReservedWordXOR";
    FormulasErrorsStrings[FormulasErrorsStrings["ReservedWordIf"] = 3] = "ReservedWordIf";
    FormulasErrorsStrings[FormulasErrorsStrings["NumberContains2DecimalPoints"] = 4] = "NumberContains2DecimalPoints";
    FormulasErrorsStrings[FormulasErrorsStrings["ReservedWordElse"] = 5] = "ReservedWordElse";
    FormulasErrorsStrings[FormulasErrorsStrings["ReservedWordNOT"] = 6] = "ReservedWordNOT";
    FormulasErrorsStrings[FormulasErrorsStrings["InvalidCharInNumber"] = 7] = "InvalidCharInNumber";
    FormulasErrorsStrings[FormulasErrorsStrings["InvalidCharactersFollowingWithOperator"] = 6] = "InvalidCharactersFollowingWithOperator";
    FormulasErrorsStrings[FormulasErrorsStrings["MismatchedParentheses"] = 8] = "MismatchedParentheses";
    FormulasErrorsStrings[FormulasErrorsStrings["UnknownFormulaName"] = 9] = "UnknownFormulaName";
    FormulasErrorsStrings[FormulasErrorsStrings["RequiresASingleArgument"] = 10] = "RequiresASingleArgument";
    FormulasErrorsStrings[FormulasErrorsStrings["Requires3Args"] = 11] = "Requires3Args";
    FormulasErrorsStrings[FormulasErrorsStrings["InvalidMathArgument"] = 12] = "InvalidMathArgument";
    FormulasErrorsStrings[FormulasErrorsStrings["Requires2Args"] = 13] = "Requires2Args";
    FormulasErrorsStrings[FormulasErrorsStrings["BadIndex"] = 14] = "BadIndex";
    FormulasErrorsStrings[FormulasErrorsStrings["TooComplex"] = 15] = "TooComplex";
    FormulasErrorsStrings[FormulasErrorsStrings["CircularReference"] = 16] = "CircularReference";
    FormulasErrorsStrings[FormulasErrorsStrings["MissingFormula"] = 17] = "MissingFormula";
    FormulasErrorsStrings[FormulasErrorsStrings["ImproperFormula"] = 18] = "ImproperFormula";
    FormulasErrorsStrings[FormulasErrorsStrings["InvalidExpression"] = 19] = "InvalidExpression";
    FormulasErrorsStrings[FormulasErrorsStrings["CellEmpty"] = 20] = "CellEmpty";
    FormulasErrorsStrings[FormulasErrorsStrings["BadFormula"] = 21] = "BadFormula";
    FormulasErrorsStrings[FormulasErrorsStrings["EmptyExpression"] = 22] = "EmptyExpression";
    FormulasErrorsStrings[FormulasErrorsStrings["VirtualModeRequired"] = 23] = "VirtualModeRequired";
    FormulasErrorsStrings[FormulasErrorsStrings["MismatchedTics"] = 24] = "MismatchedTics";
    FormulasErrorsStrings[FormulasErrorsStrings["WrongNumberArguments"] = 25] = "WrongNumberArguments";
    FormulasErrorsStrings[FormulasErrorsStrings["InvalidArguments"] = 26] = "InvalidArguments";
    FormulasErrorsStrings[FormulasErrorsStrings["IterationsDoNotConverge"] = 27] = "IterationsDoNotConverge";
    FormulasErrorsStrings[FormulasErrorsStrings["CalculationOverflow"] = 29] = "CalculationOverflow";
    FormulasErrorsStrings[FormulasErrorsStrings["AlreadyRegistered"] = 28] = "AlreadyRegistered";
    FormulasErrorsStrings[FormulasErrorsStrings["MissingSheet"] = 30] = "MissingSheet";
    FormulasErrorsStrings[FormulasErrorsStrings["CannotParse"] = 31] = "CannotParse";
    FormulasErrorsStrings[FormulasErrorsStrings["ExpressionCannotEndWithAnOperator"] = 32] = "ExpressionCannotEndWithAnOperator";
    FormulasErrorsStrings[FormulasErrorsStrings["Spill"] = 33] = "Spill";
    FormulasErrorsStrings[FormulasErrorsStrings["Div"] = 34] = "Div";
})(FormulasErrorsStrings || (FormulasErrorsStrings = {}));
/**
 * @hidden
 */
export var ExcelFileFormats;
(function (ExcelFileFormats) {
    ExcelFileFormats["xlsx"] = "xlsx";
    ExcelFileFormats["xlsm"] = "xlsm";
    ExcelFileFormats["xlsb"] = "xlsb";
    ExcelFileFormats["xltx"] = "xltx";
    ExcelFileFormats["xltm"] = "xltm";
    ExcelFileFormats["xls"] = "xls";
    ExcelFileFormats["xml"] = "xml";
    ExcelFileFormats["xlam"] = "xlam";
    ExcelFileFormats["xla"] = "xla";
    ExcelFileFormats["xlw"] = "xlw";
    ExcelFileFormats["xlr"] = "xlr";
    ExcelFileFormats["prn"] = "prn";
    ExcelFileFormats["txt"] = "txt";
    ExcelFileFormats["csv"] = "csv";
    ExcelFileFormats["dif"] = "dif";
    ExcelFileFormats["slk"] = "slk";
})(ExcelFileFormats || (ExcelFileFormats = {}));
